export enum AnalyticsGraphSummaryValueName {
  ORDERS = 'orders',
  PRODUCTION_COUNTRIES = 'production_countries',
  DESTINATION_COUNTRIES = 'destination_countries',
  PRINTJOBS = 'printjobs',
  PRINTJOBS_PER_ORDER = 'printjobs_per_order',
  PRINTING_COST = 'printing_cost',
}
